import React from "react";

// Small inline SVG flags (not emoji — Catalonia has no Unicode flag emoji,
// so all three are rendered the same way for visual consistency).
const flagStyle = { display: "inline-block", borderRadius: "1px", flexShrink: 0 };

export function FlagES({ size = 16 }) {
    return (
        <svg viewBox="0 0 3 2" width={size} height={size * (2 / 3)} style={flagStyle} aria-hidden="true">
            <rect width="3" height="2" fill="#AA151B" />
            <rect y="0.5" width="3" height="1" fill="#F1BF00" />
        </svg>
    );
}

export function FlagGB({ size = 16 }) {
    return (
        <svg viewBox="0 0 60 30" width={size} height={size / 2} style={flagStyle} aria-hidden="true">
            <rect width="60" height="30" fill="#00247d" />
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#cf142b" strokeWidth="2" />
            <path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10" />
            <path d="M30,0 V30 M0,15 H60" stroke="#cf142b" strokeWidth="6" />
        </svg>
    );
}

export function FlagCAT({ size = 16 }) {
    return (
        <svg viewBox="0 0 900 600" width={size} height={size * (2 / 3)} style={flagStyle} aria-hidden="true">
            <rect width="900" height="600" fill="#FCDD09" />
            <rect y="66.67" width="900" height="66.67" fill="#DA121A" />
            <rect y="200" width="900" height="66.67" fill="#DA121A" />
            <rect y="333.33" width="900" height="66.67" fill="#DA121A" />
            <rect y="466.67" width="900" height="66.67" fill="#DA121A" />
        </svg>
    );
}

export const FLAG_BY_LANG = { es: FlagES, en: FlagGB, ca: FlagCAT };
